module.exports = __webpack_public_path__ + "media/images/athletes/3408-a68b23ea5540a584ac7624db3ebe06e0.png";